var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"roles-info"},[_c('h4',{staticClass:"title"},[_vm._v(" Roles ")]),_c('div',{staticClass:"content"},[(_setup.props.warning)?_c('div',[_vm._v(" Tri ")]):_vm._e(),_c('p',[_vm._v(_vm._s(_setup.props.numRoles || 0)+" roles")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }